import { ManagedTrainingsListOrderBy } from "generated/CoreApi_v1";
import React, { PropsWithChildren } from "react";
import { Outlet } from "react-router";
import { IAdvFilterParams } from "views/general/AdvancedFilter";
import { TrainingNavigationSource } from "views/lms/training/Home/EditTraining";

////////////////////////////////////////////////////////////////////////////////

export interface TrainingListFilter extends IAdvFilterParams<ManagedTrainingsListOrderBy> {
  onlyActive: boolean;
  dt: Date;
}

type TrainingListPagination = {
  page: number;
};

type TrainingContextType = {
  filter: TrainingListFilter;
  setFilter: (data: Partial<TrainingListFilter>) => void;
  resetFilter: () => void;
  editNavigation: TrainingNavigationSource[];
  setEditNavigation: (data: TrainingNavigationSource[]) => void;
  pagination: TrainingListPagination;
  setPagination: (data: TrainingListPagination) => void;
};

const TrainingContext = React.createContext<TrainingContextType>(undefined!);

////////////////////////////////////////////////////////////////////////////////

export const useTrainingManagementContext = () => React.useContext(TrainingContext);

////////////////////////////////////////////////////////////////////////////////

const TrainingManagementWrapper: React.FC<PropsWithChildren> = () => {
  const [filter, setFilter] = React.useState<TrainingListFilter>({ searchText: "", advFilters: [], order: ManagedTrainingsListOrderBy.Name, onlyActive: true, dt: new Date() });
  const [pagination, setPagination] = React.useState<TrainingListPagination>({ page: 1 });
  const [editNavigation, setEditNavigation] = React.useState<TrainingNavigationSource[]>([]);

  const resetFilter = () => {
    setFilter(state => ({ ...state, searchText: "", advFilters: [] }));
    setPagination({ page: 1 });
  };

  return (
    <TrainingContext.Provider
      value={
        {
          filter,
          setFilter: (data: Partial<TrainingListFilter>) => setFilter(state => ({ ...state, ...data })),
          resetFilter,
          editNavigation, setEditNavigation,
          pagination, setPagination: (data: TrainingListPagination) => setPagination(data)
        }
      }
    >
      <Outlet />
    </TrainingContext.Provider>
  );
};

export default TrainingManagementWrapper;